export default "__VITE_ASSET__b64d6dd2__"